module.exports = __webpack_public_path__ + "static/Manuela-782c379dc9aede9a41431146a297a628.png";